import { Download } from "react-feather";
import { downloadableHref, imageDownloadName } from "../lib/imageDownload";
import "./ImageDownloadControl.css";

/** A sibling of the preview button, never an interactive element nested in it.
 * Only saved blobs / same-origin files support a truthful browser download. */
export default function ImageDownloadControl({ src, filename, mimeType }: {
  src: string; filename?: string; mimeType?: string;
}) {
  const href = downloadableHref(src, typeof window === "undefined" ? "https://localhost/" : window.location.href);
  if (!href) return null;
  const name = imageDownloadName(filename, mimeType);
  return <a className="imageDownload" href={href} download={name} referrerPolicy="no-referrer"
    aria-label={`Download ${name}`} title={`Download ${name}`} onClick={event => event.stopPropagation()}>
    <Download width={19} height={19} aria-hidden="true" />
  </a>;
}
